/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Preferences } from '@capacitor/preferences';
import { AlertController, IonRouterOutlet, LoadingController, ModalController, Platform, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';
import { ResetPasswordPage } from '../reset-password/reset-password.page';
import { LocationService } from '@shared/services/location.service';
// import { ResetPasswordPage } from '../reset-password/reset-password.page';

@Component({
  selector: 'app-email-validation',
  templateUrl: './email-validation.page.html',
  styleUrls: ['./email-validation.page.scss'],
  providers:[UtilService,IonRouterOutlet]
})
export class EmailValidationPage implements OnInit {

  public isInvalid: boolean = false;

  public myForm = new FormGroup({
    codeControl: new FormControl('',  Validators.compose([Validators.maxLength(6), Validators.minLength(6), Validators.required]))
  });

  code: string[] = ['', '', '', '', '', '']; // Array para armazenar os valores dos inputs
  @ViewChild('input1') input1: any;
  @ViewChild('input2') input2: any;
  @ViewChild('input3') input3: any;
  @ViewChild('input4') input4: any;
  @ViewChild('input5') input5: any;
  @ViewChild('input6') input6: any;

  submitAttempt: boolean = false;
  public email : any = '';
  private userData : any;
  // public codeValue: any;

  public backButton: Subscription|any;

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    public loadingCtrl:LoadingController,
    private util: UtilService,
    private translate: TranslateService,
    public userService: UserService,
    public toastCtrl: ToastController,
    public platform: Platform,
    public locationSvc: LocationService,
  ) { 

    Preferences.get({key:'USER_DATA'}).then(val => {
      this.userData = val.value ? JSON.parse(val.value) : null;
      this.email = this.userData.email;
    }).catch(error => {
      console.error('Error retrieving value:', error);
    });

    
  }

  ngOnInit() {}


  async goBack(){
    // Check if user is logged in
    const userData = await Preferences.get({ key: 'USER_DATA' });
    if (userData && userData.value) {
      const parsedUserData = JSON.parse(userData.value);
      if (parsedUserData.needsEmailValidation) {
        // User is logged in but email not validated, logout
        await this.modalCtrl.dismiss();
        await this.userService.clearLocalStorage();
      } else {
        // Email is already validated, just dismiss the modal
        this.modalCtrl.dismiss();
      }
    } else {
      // User is not logged in, just dismiss the modal
      this.modalCtrl.dismiss();
    }
  }

  ionViewWillEnter() {
    if(this.platform.is('android')) {
      this.backButton = this.platform.backButton.subscribe(() => {
        this.goBack();
      });
    }

  }

  ionViewWillLeave() {
    if(this.backButton){
      this.backButton.unsubscribe();
    }
  }
  async showLoading(message: string) {
    const loading = await this.loadingCtrl.create({
      message: message,
      duration: 3000,
      translucent: true,

      backdropDismiss: true
    });

    loading.present();
  }

  async showModalAlert(message: string) {
    const alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    await alert.present();
  }


  async validateCode(){
    this.submitAttempt = true;
    const fullCode = this.code.join('');
    const isNumeric = /^[0-9]{6}$/.test(fullCode);

    if(fullCode.length !=6 && !isNumeric){
      this.isInvalid = true;
      this.showModalAlert(this.translate.instant('invalidCodeTryAgain'));
      return;
    }
    const codeValue = fullCode;

    this.userService.validateTempCode(this.userData, String(codeValue)).subscribe(async (result) =>{
      console.log('result: ' + JSON.stringify(result));

      if(result.result != 'ok'){
        this.isInvalid = true;
        this.showModalAlert(this.translate.instant('invalidCodeTryAgain'));
        return;
      }
      this.isInvalid = false;
      this.userData.needsEmailValidation = false;

      // Save USER_DATA immediately to ensure it's updated before dismiss
      await Preferences.set({key:'USER_DATA', value: JSON.stringify(this.userData)});
      console.log('userdata saved to DB');

      const userId = this.userData?._id.$oid;
      console.log('userData._id.$oi: '+ userId);

      this.userService.setEmailValidated(userId, this.userData).subscribe(data =>{
        console.log(JSON.stringify(data));
        // Update USER_DATA again after server confirms validation
        Preferences.set({key:'USER_DATA', value: JSON.stringify(this.userData)}).then((_val) =>{
          console.log('userdata saved to DB after server confirmation');
        });
      },
      err =>{
        this.util.showToastUnableToConnect(this.toastCtrl);
        console.log('Error setting the email as validated in the server for user : ' + userId + 'Error was: ' + JSON.stringify(err));
      });

      if(this.userData.needsPasswordReset){
        this.goToResetPasswordPage();
      }else {
        // Ensure USER_DATA is saved before dismissing
        await Preferences.set({key:'USER_DATA', value: JSON.stringify(this.userData)});
        this.modalCtrl.dismiss('loggedIn');
      }
      
      
    }, err =>{
      console.error('Error to validateTempCode on server..');
      console.error('Error: ' + JSON.stringify(err));
      this.util.showToastUnableToConnect(this.toastCtrl);
    })
  }
  

  handlePaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
  
    // Verifica se o valor colado tem exatamente 6 caracteres e são números
    if (/^\d{6}$/.test(pastedText)) {
      for (let i = 0; i < pastedText.length; i++) {
        this.code[i] = pastedText.charAt(i);  // Preenche o array com os dígitos
      }
      
      // Atualiza o foco para o último input após preencher
      this.input6.setFocus();
    }
  
    event.preventDefault(); // Previne que o conteúdo colado sobrescreva o primeiro input
  }

  async goToResetPasswordPage(){

    const modal = this.modalCtrl.create({
      component: ResetPasswordPage, 
    });

    (await modal).onDidDismiss().then((val) => {
      if (val && val.data === "loggedIn") {
        this.modalCtrl.dismiss('loggedIn');
      }
    });

    (await modal).present();

  }

  async sendAgain(){
    const loader = this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
      // duration: 10000
    });
    (await loader).present();

    let theObs : Observable<any>;

    Preferences.get({key:'LAST_LOCATION'}).then(val =>{
      val = val.value ? JSON.parse(val.value) : null;
      let location = val;
      const teleportationLocation = this.locationSvc.getTeleportationLocation();

      if(teleportationLocation != null){
        location = teleportationLocation;
      }

      theObs = this.userService.upsertSoul(this.userData, location, false, false, false);

      theObs.subscribe(async data => {
        console.log('upsert subscribe entered');
        console.log(JSON.stringify(data));

        if(data != '{not ok}'){
          this.userData = JSON.parse(data);
          Preferences.set({key:'USER_DATA', value: JSON.stringify(this.userData)}).then((_val) =>{
            console.log('userdata saved to DB');
          });
          (await loader).dismiss();
          this.showModalAlert(this.translate.instant('newCodeSentSuccessfully') + this.userData.email);
        } else {
          (await loader).dismiss();
        }


      },
      async err => {
        console.log('Error: ' + JSON.stringify(err));
        //alert('Invalid email or password. Please, try again');
        this.util.showToastUnableToConnect(this.toastCtrl);
        (await loader).dismiss();
      });

    });

  }

  moveFocus(event: any, nextInput: any) {
    const inputValue = event.target.value;

    // Verifica se o valor digitado tem 1 caractere
    if (inputValue.length === 1 && nextInput) {
      nextInput.setFocus(); // Move o foco para o próximo input
    }
  }

  // Função para voltar ao input anterior ao pressionar 'Backspace'
  moveBack(event: any, prevInput: any) {
    const inputValue = event.target.value;

    // Verifica se o campo está vazio ao pressionar 'Backspace' e move para o input anterior
    if (event.key === 'Backspace' && inputValue.length === 0 && prevInput) {
      prevInput.setFocus();
    }
  }


}
